import React from 'react';
import {extractContent, dateToMonth} from './lib';
import moment from 'moment';

//Image fallback
const DEFAULT_IMAGE = 'https://www.mp-plus.com/wp-content/uploads/2017/01/I_Assertivite-300x200.jpg';

//Single course template
const Course = (course)=>{    
    moment.locale('fr');
    //parsing and formating
    const dateObject = moment(course.start, 'YYYY-MM-DD hh:mm:ss');
    //reparsing (fixes issue with old browsers)
    const momentDateObject = moment(dateObject);
    //extract the month
    const month = dateToMonth(dateObject);
    //extract the day
    let when = momentDateObject.format('LLLL').split(' '); // mardi 14 mars 2017 02:01

    //when without time
    when.pop();
    //when without years
    when.pop();
    
    //All months of the years
    const months = moment.months();

    const Full = (
    <div></div>        
    )

    //Gauge display
    const Almostfull = (
        <div className="places_left">
            <img src="https://www.mp-plus.com/wp-content/uploads/2017/03/gauge_red.png"/>
            <span style={{ textAlign: 'center', textTransform:'capitalize'}}>Places très limitées</span>
        </div>
    )

    const Halffull = (
        <div className="places_left">
            <img src="https://www.mp-plus.com/wp-content/uploads/2017/03/gauge_yellow.png"/>
            <span style={{ textAlign: 'center', textTransform:'capitalize'}}>Places limitées</span>

        </div>
    )

    const Available = (
        <div className="places_left">
            <img src="https://www.mp-plus.com/wp-content/uploads/2017/03/gauge_green.png"/>
            <span style={{ textAlign: 'center', textTransform:'capitalize'}}>Places disponibles</span>
        </div>
       
    )

    const Description = (course) => { 
        if (course.places_left !== 'full') {
            return <div className="description" dangerouslySetInnerHTML={{ __html: course.description }} />
        } else { 
            return <div className="course-is-full"><img width='100px' src="https://www.mp-plus.com/wp-content/uploads/2017/03/Complet_preview.jpg"/></div>
        }
    }

  

    const displayGauge = (placeLeft) => { 
        switch (placeLeft) { 
            case 'full':
                return Full;
                break;
            case 'almost-full':
                return Almostfull
                break;
            case 'half-full':
                return Halffull
                break;    
            case 'available':
                return Available
                break;    
            default:
                return ''
        }
    }

   
    return (
        <div> 
        <div className={month + ' card animated flipInX'}>
            <div className="post-content">
                <h2 className="title">
                    {course.title}
                </h2>
                <div style={{position:'relative'}}>
                    <img className="mp-thumb" src={course.img_src ? course.img_src : DEFAULT_IMAGE} />        
                    <div id="mp-overlay" className={course.places_left} onClick={()=>window.open(course.url, '_blank')}>
                        <span id="plus">+</span>
                    </div>        
                </div>
                <div className="display-month">
                    {months[momentDateObject.get('month')]}
                </div>
            
               
                
                <div className="when">
                    {Array.prototype.join.call(when, ' ')}
                </div>

                <div className="category">
                    {course.region}
                </div>


                {Description(course)}
              

                <div className="post-meta">      
                        {displayGauge(course.places_left)}
                </div>

            </div>
        </div>
        </div>
    )
}

const Loading = (
    <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
    </div>
)


export {Course, Loading}



/** WEBPACK FOOTER **
 ** ./src/components/widget/helpers.js
 **/